export const saFaq = [
    {
        title: `Jakie usługi oferuje racoongo.pl?`,
        text: `racoongo.pl - porównywarka szybkich pożyczek online. Jesteśmy pośrednikiem pomiędzy Tobą a najlepszymi pożyczkodawcami w Polsce. Na naszej          stronie możesz wygodnie i prosto:
            <ul>
                <li>- porównać warunki najpopularniejszych produktów pożyczkowych,</li>
                <li>- wysłać jeden wniosek o pożyczkę i od razu otrzymać propozycję od kilku pożyczkodawców oraz wybrać najlepszy wariant,</li>
                <li>- zarejestrować się na stronie i z zrobić to wszystko na indywidualnym koncie.</li>
            </ul>`
    },
    {
        title: `Ile kosztują usługi racoongo.pl?`,
        text: `Wszystkie usługi na stronie racoongo.pl są da Ciebie całkowicie bezpłatne - rejestracja, wysłanie wnioseku o przyznanie kredytu, a także usługa weryfikacji rachunku bankowego.`
    },
    {
        title: `Ile pieniędzy mogę pożyczyć?`,
        text: `Możesz ubiegać się o pożyczkę w wysokości od 50 do 5000 PLN z terminem zapadalności do 60 dni. Decyzja o wysokości pożyczki zostanie podjęta przez Pożyczkodawcę.`
    },
    {
        title: `Jak długo trwa proces uzyskiwania pożyczek?`,
        text: `Proces odbywa się 100 % online, ale szybkość przelania pożyczki na Twoje konto zależy od systemu księgowania pieniędzy w Twoim banku. Czas oczekiwania na pieniądze nie może przekroczyć 1 dnia.`
    },
    {
        title: `Czy dostanę pieniądze w sobotę lub niedzielę?`,
        text: `Wszystko zależy od pracy banku. Jeśli masz konto w tym samym banku to jest szansa, że pieniądze trafią do Ciebie również w weekend.
            Jednak musisz wziąć też pod uwagę sytuację, w której składając wniosek w piątek wieczorem, pieniądze otrzymasz dopiero w poniedziałek.`
    },
    {
        title: `Na co mogę wziąć pożyczkę?`,
        text: `Pożyczkę możesz wziąć na dowolny cel, nie wymagamy podania powodu dla którego składasz wniosek.`
    },
    {
        title: `Czy mogę otrzymać pożyczkę w gotówce?`,
        text: `Niestety nie ma takiej możliwości. Firmy pożyczkowe z którymi współpracujemy oferują tylko przelewy online.
            Pieniądze trafią bezpośrednio na Twoje konto bankowe, które wskazano we wniosku, dlatego bardzo ważnym jest aby wszystkie dane były aktualne.`
    },
    {
        title: `Jakie warunki muszę spełnić, aby otrzymać pożyczkę?`,
        text: `Musisz:
            <ul>
                <li>- być osobą pełnoletnią,</li>
                <li>- posiadać stały dochód,</li>
                <li>- być obywatelem Polski,</li>
                <li>- posiadać konto bankowe założoną na swoje imię i nazwisko..</li>
            </ul>
            Inne wymagania mogą się różnić w zależności od firmy pożyczkowej.`
    },
    {
        title: `Co jeżeli mam niekorzystną historię kredytową?`,
        text: `racoongo.pl nie jest Pożyczkodawcą, dlatego nie prowadzi analizy Twojej historii kredytowej i zdolności kredytowej.
            Nasza usługa polega na przekazaniu Twoich danych Pożyczkodawcom, którzy wstępnie zaakceptowali Twój wniosek. Pożyczkodawca może sprawdzić historię kredytową i złożyć zapytanie do bazy danych dłużników.
            Pamiętaj jednak, że historia kredytowa może mieć wpływ na to, czy pożyczka zostanie udzielona, czy nie.
            W każdym przypadku zalecamy korzystanie z naszej porównywarki, wyszukiwać i porównywać oferty Pożyczkodawców oraz wysyłać wnioski. W wielu przypadkach wniosek o pożyczkę nie zostanie pozostawiony bez odpowiedzi przez Pożyczkodawców i pożyczka zostanie udzielona.`
    },
    {
        title: `Dlaczego mój wniosek nie został zatwierdzony?`,
        text: `racoongo.pl zapewnia darmowe wyszukiwanie i porównanie pożyczek osobistych. Proces analizy i zatwierdzenia wniosku jest przeprowadzany przez wybranego pożyczkodawcę. Każdy pożyczkodawca posiada własną procedurę.
            Pożyczkodawcy mogą wziąć pod uwagę historię kredytową, test wypłacalności i weryfikację listy osób niewywiązujących się z płatności.
            Jednak powód, przez który klient nie otrzymał pożyczki, może zostać podany jedynie przez wybraną instytucję. Radzimy więc skontaktować się z nią, aby dokładnie wiedzieć przyczynę i móc rozwiązać problem.`
    },
    {
        title: `Chciałbym zrezygnować z pożyczki, którą otrzymałem. Mogę to zrobić?`,
        text: `Oczywiście, zgodnie z prawem masz 14 dni na odstąpienie od umowy od momentu jej podpisania.`
    },
    {
        title: `Jak mam spłacić pożyczkę?`,
        text: `Pożyczkę spłacasz przelewem na konto pożyczkodawcy. Wszystkie niezbędne dane otrzymasz na swojego maila. Możesz oczywiście spłacić całość zobowiązania wcześniej.
            Pamiętaj jednak aby nie przekroczyć terminu spłaty – spowoduje to naliczenie dodatkowych opłat.`
    },
    {
        title: `Czy mogę wydłużyć termin spłaty kredytów?`,
        text: `Tak. W tym celu konieczny jest kontakt z firmą pożyczkową, która wyjaśni Ci dostępne możliwości. Pamiętaj, że za wydłużenie terminu spłaty zostaje naliczona dodatkowa opłata. O szczegóły zapytaj bezpośrednio pracownika firmy.`
    },
    {
        title: `Jakie są konsekwencje braku spłaty pożyczki?`,
        text: `Jeżeli masz problem ze spłatą pożyczki, powiadom o tym firmę pożyczkową. W przeciwnym wypadku możesz zostać wpisany do Krajowego Rejestru Długów. Pożyczkodawca naliczy także dodatkowe opłaty za nieterminową spłatę i będzie się z Tobą kontaktował w celu ustalenia nowej daty płatności.
            Jeżeli nie skomunikujesz się z nim, będzie mógł wdrożyć postępowanie windykacyjne.`
    },
    {
        title: `W jaki sposób mogę zażądać usunięcia moich danych?`,
        text: `Prosimy o przesłanie wiadomości na adres support@racoongo.com podając w niej następujące dane: imię, nazwisko, PESEL, numer telefonu, adres e-mail. Podane dane odpowiadają tym, które zostały zgłoszone przez wniosek. Prośba zostanie wykonana w terminie 30 dni lub wcześnie, zgodnie z «Polityką prywatności».`
    }
]



// WEBPACK FOOTER //
// src/js/controllers/singleApplication/sa-faq.js